@if (activeResource) {
<app-screen
    class="screen"
    [resource]="activeResource"
    [teacherMode]="true"
    [autoload]="true"
></app-screen>
}
